var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zoneListeProduits" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "spinner" }, [
            _c("i", { staticClass: "fa fa-circle-o-notch fa-spin fa-3x" }),
            _c("br"),
            _vm._v("Chargement...")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.products, function(p, k, i) {
        return [
          _vm.selection &&
          (2 === i || 2 === k) &&
          _vm.selection.imagePromo1.path
            ? _c("div", { staticClass: "blocProduit imgSelection" }, [
                _vm.selection.linkPromo1
                  ? _c("a", { attrs: { href: _vm.selection.linkPromo1 } }, [
                      _c("img", {
                        staticClass: "lazyload img-fluid",
                        attrs: { "data-src": _vm.selection.imagePromo1.path }
                      })
                    ])
                  : _c("img", {
                      staticClass: "lazyload img-fluid",
                      attrs: { "data-src": _vm.selection.imagePromo1.path }
                    })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selection &&
          (5 === i || 5 === k) &&
          _vm.selection.imagePromo2.path
            ? _c("div", { staticClass: "blocProduit imgSelection" }, [
                _vm.selection.linkPromo2
                  ? _c("a", { attrs: { href: _vm.selection.linkPromo2 } }, [
                      _c("img", {
                        staticClass: "lazyload img-fluid",
                        attrs: { "data-src": _vm.selection.imagePromo2.path }
                      })
                    ])
                  : _c("img", {
                      staticClass: "lazyload img-fluid",
                      attrs: { "data-src": _vm.selection.imagePromo2.path }
                    })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("ponroy-product-card", {
            attrs: {
              id: p.id,
              title: p.title,
              isNewFormula: false,
              isNew: _vm.isNew(p),
              bestSales: _vm.bestSales(p),
              provenSatisfaction: false,
              provenEffectiveness: false,
              isRecommended: false,
              url: p.url,
              cardImage: p.cardImage,
              shortDescription: p.shortDescription,
              subtitle: p.subtitle,
              references: p.references,
              lowestPrice: p.lowestPrice,
              lowestBasePrice: p.lowestBasePrice,
              reviews: p.reviews,
              reviewsAvg: p.reviewsAvg,
              available: !p.unavailable,
              repository: "site.repository.product_reference"
            }
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa86c878", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa86c878","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/ProductGroup.vue
// module id = 516
// module chunks = 1